import type { UIMessage } from 'ai';

const CHAT_MESSAGES_KEY = 'chat-messages';

export const cacheKey = (chatId: string) => `chat-messages-${chatId}`;

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const failSilently = (fn: Function) => {
  try {
    return fn();
  } catch (e) {
    // Do nothing
    return undefined;
  }
};

// Helper functions for managing chat messages in localStorage
export const ChatMessagesStorage = {
  getAll: (): Record<string, UIMessage[]> => {
    try {
      const stored = localStorage.getItem(CHAT_MESSAGES_KEY);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  },

  get: (chatId: string): UIMessage[] => {
    const allMessages = ChatMessagesStorage.getAll();
    return allMessages[chatId] || [];
  },

  save: (chatId: string, messages: UIMessage[]): void => {
    try {
      const allMessages = ChatMessagesStorage.getAll();
      allMessages[chatId] = messages;
      localStorage.setItem(CHAT_MESSAGES_KEY, JSON.stringify(allMessages));
    } catch {
      // Silently fail if localStorage is unavailable
    }
  },

  remove: (chatId: string): void => {
    try {
      const allMessages = ChatMessagesStorage.getAll();
      delete allMessages[chatId];
      localStorage.setItem(CHAT_MESSAGES_KEY, JSON.stringify(allMessages));
    } catch {
      // Silently fail if localStorage is unavailable
    }
  },
};
